class DataVampire {
  stores: any[] = [];
  constructor(stores: any[]) {
    if (stores.length) {
      this.stores.push(...stores);
    }
  }

  save() {
    //console.debug("Saving stores to DataVampire");
    for (let i = 0; i < this.stores.length; ++i) {
      sessionStorage.setItem(...this.getStoreInfo(i));
    }
  }

  reload() {
    console.log("Reloading stores from DataVampire");
    for (let i = 0; i < this.stores.length; ++i) {
      try {
        this.stores[i]._vamp(
          //@ts-expect-error
          JSON.parse(sessionStorage.getItem(this.privateKey(i))),
        );
      } catch (e) {}
    }
    return;
  }

  getStoreInfo(index: number): [string, string] {
    return [
      this.privateKey(index),
      JSON.stringify(this.stores[index]._unvamp()),
    ];
  }

  private privateKey(index: number): string {
    return `DATAVMP_${index}`;
  }
}

export { DataVampire };
